module.exports = __webpack_public_path__ + "static/media/crocodile.89bfcf00.jpg";